// import Swiper from 'swiper';
// import 'remodal';

// ナビゲーションアニメーション
const funcNav = () => {
	const areas = document.querySelectorAll('.area');
	const navItems = document.querySelectorAll('.side nav li');
	if (!areas.length || !navItems.length) return;

	const areasArray = [...areas];
	const check = (entries) => {
		entries.forEach((entry) => {
			const index = areasArray.indexOf(entry.target);
			if (index === -1) return;

			if (entry.isIntersecting) {
				navItems.forEach((item) => item.classList.remove('active'));
				if (navItems[index]) navItems[index].classList.add('active');
			} else {
				if (navItems[index]) navItems[index].classList.remove('active');
			}
		});
	};

	const options = {
		rootMargin: '0px 0px -90% 0px',
		threshold: 0,
	};

	const observer = new IntersectionObserver(check, options);
	areas.forEach((target) => observer.observe(target));
};

// スクロールアニメーション
const funcAnim = () => {
	const items = document.querySelectorAll('.anim');
	if (!items.length) return;

	const check = () => {
		const th = window.innerHeight * 0.9;
		items.forEach((el) => {
			if (el.classList.contains('active')) return;
			const r = el.getBoundingClientRect();
			if (r.top < th && r.bottom > 0) el.classList.add('active');
		});
	};

	check();
	if (document.readyState !== 'complete') {
		window.addEventListener('load', check, { once: true });
	}
	window.addEventListener('scroll', check, { passive: true });
	window.addEventListener('resize', check);
};

// コンセプト：カウントダウン桁（発売日までの日数に応じて li に show）
const funcConceptCount = () => {
	const root = document.querySelector('.concept__count');
	if (!root) return;

	const items = root.querySelectorAll('ul li');
	if (!items.length) return;

	// 発売日（ローカル日付 0:00 基準）— 変更時はここだけ更新
	const releaseY = 2026;
	const releaseM = 5;
	const releaseD = 13;

	const today = new Date();
	const startToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
	const releaseDay = new Date(releaseY, releaseM - 1, releaseD);
	const daysLeft = Math.round((releaseDay - startToday) / (24 * 60 * 60 * 1000));

	// ul の並び [5,4,3,2,1,0] に対応。5日超は 5、発売日以降は 0
	const index = Math.min(items.length - 1, Math.max(0, 5 - Math.min(daysLeft, 5)));

	items.forEach((li, i) => {
		li.classList.toggle('show', i === index);
	});
};

// スムーススクロール
const easeInOut = (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1);
const duration = 500;

window.addEventListener('DOMContentLoaded', () => {
	const triggers = document.querySelectorAll('.anchor');
	const areas = document.querySelectorAll('.area');
	const navItems = document.querySelectorAll('.side nav li');
	const areasArray = [...areas];

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			const href = trigger.getAttribute('href');
			if (!href || !href.startsWith('#')) return;

			const targetId = href.slice(1);
			if (!targetId) return;

			const targetElement = document.getElementById(targetId);
			if (!targetElement) return;

			e.preventDefault();
			e.stopPropagation();

			const currentPosition = window.scrollY || 0;
			const targetPosition = currentPosition + targetElement.getBoundingClientRect().top - 0;
			const distance = targetPosition - currentPosition;
			const startTime = performance.now();

			const loop = (nowTime) => {
				const time = nowTime - startTime;
				const normalizedTime = time / duration;

				if (normalizedTime < 1) {
					window.scrollTo(0, currentPosition + distance * easeInOut(normalizedTime));
					requestAnimationFrame(loop);
				} else {
					window.scrollTo(0, targetPosition);

					// funcNav等要素を取る時（発火位置調整）
					setTimeout(() => {
						const index = areasArray.indexOf(targetElement);
						if (index !== -1 && navItems[index]) {
							navItems.forEach((item) => item.classList.remove('active'));
							navItems[index].classList.add('active');
						}
					}, 100); // IntersectionObserverの更新を待つ
				}
			};

			requestAnimationFrame(loop);
		});
	});

	// グローバルナビゲーション（.navi-gloval）：スクロール中は .show を外し、止まったら .show
	// header / .kv 内のスクロール位置では発火しない（.kv 下端より下に出てから）
	const GLOBAL_NAV_SCROLL_IDLE_MS = 150;
	const globalNav = document.querySelector('.navi-gloval');
	if (globalNav) {
		let scrollTimer;
		window.addEventListener(
			'scroll',
			() => {
				const scrollY = window.scrollY || window.pageYOffset;
				const kvEl = document.querySelector('.kv');
				const headerEl = document.querySelector('.inrWrap > header');
				let excludeUntilY = 0;
				if (kvEl) {
					excludeUntilY = scrollY + kvEl.getBoundingClientRect().bottom;
				} else if (headerEl) {
					excludeUntilY = scrollY + headerEl.getBoundingClientRect().bottom;
				}
				if (scrollY < excludeUntilY) {
					clearTimeout(scrollTimer);
					return;
				}

				globalNav.classList.remove('show');
				clearTimeout(scrollTimer);
				scrollTimer = window.setTimeout(() => {
					globalNav.classList.add('show');
				}, GLOBAL_NAV_SCROLL_IDLE_MS);
			},
			{ passive: true },
		);
	}

	// OPENING
	const OP_STORAGE_KEY = 'sc2026nontan_op_last';
	const OP_INTERVAL_MS = 24 * 60 * 60 * 1000; // 24時間

	const urlParam = new URLSearchParams(location.search).get('op');
	const lastShown = localStorage.getItem(OP_STORAGE_KEY);
	const withinInterval = lastShown && Date.now() - Number(lastShown) < OP_INTERVAL_MS;
	const skipOpening = urlParam === '0' || (urlParam !== '1' && withinInterval);

	const afterOpening = () => {
		const opEl = document.querySelector('.op');
		if (opEl) opEl.style.display = 'none';

		const ttl = document.querySelector('.header__ttl');
		if (ttl) ttl.classList.add('active');
		const headerObj = document.querySelector('header .obj');
		if (headerObj) headerObj.classList.add('active');
		const kv = document.querySelector('.kv');
		if (kv) kv.classList.add('active');
		const kvObj = document.querySelector('.kv .obj');
		if (kvObj) kvObj.classList.add('active');
		const kvFader = document.querySelector('.kv__fader');
		if (kvFader) kvFader.classList.add('fader');
		const lead = document.querySelector('.concept__lead');
		if (lead) lead.classList.add('active');
		document.querySelectorAll('.side').forEach((side) => side.classList.add('fade'));

		funcAnim();
	};

	const phase1 = document.querySelector('.phase1');
	if (phase1 && !skipOpening) {
		localStorage.setItem(OP_STORAGE_KEY, Date.now());

		function noScroll(event) {
			event.preventDefault();
		}
		document.addEventListener('wheel', noScroll, {
			passive: false,
		});
		document.addEventListener('touchmove', noScroll, {
			passive: false,
		});

		const animEls = phase1.querySelectorAll('.anim');
		animEls.forEach((el) => el.classList.add('active'));

		const animTotal = animEls.length;
		let animEnded = 0;
		let openingDone = false;

		phase1.addEventListener('animationend', function onOpeningAnimEnd() {
			animEnded += 1;
			if (animEnded < animTotal || openingDone) return;
			openingDone = true;

			document.removeEventListener('wheel', noScroll, {
				passive: false,
			});
			document.removeEventListener('touchmove', noScroll, {
				passive: false,
			});

			setTimeout(() => {
				const opHidden = document.querySelector('.op');
				if (opHidden) opHidden.classList.add('hidden');
			}, 500);

			setTimeout(() => {
				afterOpening();
			}, 1000);
		});
	} else {
		afterOpening();
	}

	// ※ funcAnim() はオープニング有の場合は上の setTimeout 内で呼ぶ（オーバーレイ中にアニメが終わるのを防ぐ）

	// ナビゲーションアニメーション;
	funcNav();

	// コンセプトカウント（日付で show）
	funcConceptCount();
});
